/**
 * CPF e CNPJ conferidos pelo digito verificador, espelhando as regras do
 * servidor (App\Rules\CpfValido e App\Rules\CnpjValido).
 *
 * Existe para a tela avisar enquanto a pessoa digita, em vez de recusar so
 * depois de enviar. O servidor continua sendo a autoridade: isto aqui e
 * conveniencia, nao validacao.
 */

export const apenasDigitos = (valor: string): string => (valor || '').replace(/\D/g, '');

export const cpfValido = (valor: string): boolean => {
  const digitos = apenasDigitos(valor);

  if (digitos.length !== 11) return false;
  // Todos os digitos iguais passam na conta dos verificadores e precisam sair antes.
  if (/^(\d)\1{10}$/.test(digitos)) return false;

  return [9, 10].every((posicao) => {
    let soma = 0;
    for (let i = 0; i < posicao; i++) {
      soma += Number(digitos[i]) * (posicao + 1 - i);
    }
    const resto = soma % 11;
    return Number(digitos[posicao]) === (resto < 2 ? 0 : 11 - resto);
  });
};

export const cnpjValido = (valor: string): boolean => {
  const digitos = apenasDigitos(valor);

  if (digitos.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(digitos)) return false;

  return [12, 13].every((posicao) => {
    let peso = posicao - 7;
    let soma = 0;
    for (let i = 0; i < posicao; i++) {
      peso = peso === 1 ? 9 : peso - 1;
      soma += Number(digitos[i]) * peso;
    }
    const resto = soma % 11;
    return Number(digitos[posicao]) === (resto < 2 ? 0 : 11 - resto);
  });
};

/** Documento de fornecedor: CPF ou CNPJ, decidido pela quantidade de digitos. */
export const documentoValido = (valor: string): boolean => {
  const digitos = apenasDigitos(valor);
  if (digitos.length === 11) return cpfValido(digitos);
  if (digitos.length === 14) return cnpjValido(digitos);
  return false;
};
